import { createContext, useContext, useState } from 'react';
import Handler from '../services';
import toast from 'react-hot-toast';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState(null);
    console.log("userInfo da authContext", userInfo)
    const handler = Handler();
    const login = async (email, password) => {
        try {
            const oClinica = await handler.login(email, password);
            setUserInfo(oClinica);
        } catch (err) {
            toast.error(err.message);
            console.log("Errore:", err)
        }
    }

    const logout = () => {
        setUserInfo(null)
    };

    return (
        <AuthContext.Provider value={{ userInfo, login, logout}}>
            {children}
        </AuthContext.Provider>
    );
};


export const useAuth = () => {
    return useContext(AuthContext);
};